import React, { useState , useEffect } from "react";
import { calender, logo } from "../../images";
import styles from "./Header.module.css";
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdClose } from "react-icons/md";
import { GetAccount } from "../contracts/functions/account";

const Header = () => {
  const [account ,setAccount] = useState("Connect Wallet");
  const [sidebar, setSidebar] = useState(false);
  const navArray = [
    { navItem: "Homepage", to: "/" },
    { navItem: "NFT Marketplace", to: "/" },
  ];
  return (
    <section className={styles.header}>
      <Link to="/" className={styles.logoWrapper}>
        <div className={styles.logoContainer}>
          <img src={logo} alt="Logo" className={styles.logo} />
          <h5 className={styles.logoText}>LUART</h5>
        </div>
      </Link>
      {sidebar ? (
        <MdClose
          className={styles.icon}
          onClick={() => setSidebar((prev) => !prev)}
        />
      ) : (
        <GiHamburgerMenu
          className={styles.icon}
          onClick={() => setSidebar((prev) => !prev)}
        />
      )}
      <div className={styles.navBar}>
        {navArray.map((item, index) => (
          <Link to={item.to} key={index} className={styles.navLink}>
            {item.navItem}
          </Link>
        ))}
        <div className={styles.calender}>
          <img
            src={calender}
            alt="calendder"
            className={styles.calenderImage}
          />
          <p className={styles.calenderText}>{account}</p>
        </div>
      </div>
      {sidebar && (
        <div className={styles.sidebar}>
          {navArray.map((item, index) => (
            <Link to={item.to} key={index} className={styles.navLink}>
              {item.navItem}
            </Link>
          ))}
          <div className={styles.calender}>
            <img
              src={calender}
              alt="calendder"
              className={styles.calenderImage}
            />
            <p className={styles.calenderText}>{account}</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Header;
